import React from "react";
import { TextFieldProps } from "@mui/material";
import { CustomTextField } from "./CustomTextField";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

type CustomEmailFieldProps = TextFieldProps & {
  required?: boolean;
};

export const CustomEmailField: React.FC<CustomEmailFieldProps> = ({
  value,
  helperText,
  required,
  ...rest
}) => {
  const email = String(value ?? "");

  const isEmpty = required && !email;
  const isInvalidEmail = email && !emailRegex.test(email);

  const showError = Boolean(isEmpty || isInvalidEmail);

  const errorMessage = isEmpty
    ? "Email is required"
    : isInvalidEmail
      ? "Invalid email address"
      : helperText;

  return (
    <CustomTextField
      {...rest}
      value={value}
      type="email"
      error={showError}
      helperText={errorMessage}
    />
  );
};
